import Backbone from 'backbone';
import _ from 'underscore';
import template from './moreImages.pug';

export class MoreImagesContextualAttributeView extends Backbone.View {
  initialize({
    images,
    newI18n,
    key,
    gridView,
  }) {
    this.images = images;
    this.newI18n = newI18n;
    this.key = key;
    this.gridView = gridView;
  }

  render({
    showDeliveryStatusPopup,
  }) {
    const {
      images,
      gridView,
    } = this;

    const imagesWithoutFirstImage = images.slice(1);
    const displayPopupImageUrls = [];
    const MAX_NUMBER_OF_DISPLAY_POPUOP_IMAGE = 3;
    _.each(imagesWithoutFirstImage, (image, index) => {
      if (index < MAX_NUMBER_OF_DISPLAY_POPUOP_IMAGE) {
        if (_.isNull(image.AssetIdString)) {
          displayPopupImageUrls.push(image.ThumbnailURL);
        } else {
          let imageUrlToUse = image.ImageURL;

          // strip off the resizing from MT as we need a smaller resizing
          const indexOfResizeInfo = imageUrlToUse.indexOf('&w=');
          if (indexOfResizeInfo > 0) {
            imageUrlToUse = imageUrlToUse.substr(0, indexOfResizeInfo);
          }

          const responsiveAdThumbnailWidth = 114;
          const responsiveAdThumbnailHeight = 60;
          const resizeQueryString = `&w=${responsiveAdThumbnailWidth}&h=${responsiveAdThumbnailHeight}`;

          displayPopupImageUrls.push(`${imageUrlToUse}${resizeQueryString}`);
        }
      }
    });

    // TODO: better contract between action & their callback other than window.globalCallback
    window.openEditPanel = () => gridView.trigger('openEditPanel', this.key);

    this.$el.html(template({
      displayPopupImageUrls,
      numOfImages: imagesWithoutFirstImage.length,
      maxNumOfDisplayPopupImage: MAX_NUMBER_OF_DISPLAY_POPUOP_IMAGE,
      viewMore: this.newI18n.getString(_TL_('View {{numOfRemaininfImage}} more images'), {
        numOfRemaininfImage: imagesWithoutFirstImage.length - MAX_NUMBER_OF_DISPLAY_POPUOP_IMAGE,
      }),
      openEditPanel: 'openEditPanel();',
    }));

    showDeliveryStatusPopup(this.el.outerHTML);
    return this;
  }
}
